import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { OrdersService } from 'src/app/shared/services/orders.service';


@Component({
  selector: 'app-reconciliation-success-modal',
  templateUrl: './reconciliation-success.modal.component.html',
  styleUrls: ['./reconciliation-success.modal.component.scss'],
})
export class ReconciliationSuccessModalComponent implements OnInit {
  boobleModalData: any;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private modalService: BoobleModalService,
    private readonly orderService: OrdersService
  ) { }

  ngOnInit() {
    this.orderService.updateOrderView();
  }

  closeModal() {
    this.modalService.dismiss(null);
  }

}
